import { render } from "./BylineManager.vue?vue&type=template&id=bf9b8122&lang=pug"
import script from "./BylineManager.vue?vue&type=script&lang=js"
export * from "./BylineManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__